module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing-contact"
  }, [(_vm.pageContact.elements) ? _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-articles container-fluid"
  }, [_c('div', {
    staticClass: "text-center headline-container container"
  }, [_c('h1', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.pageContact.elements.header_title.value))])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-lg-12 contact-container"
  }, [_c('div', {
    staticClass: "box-info col-lg-6 col-md-12 col-sm-12 col-xs-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.pageContact.elements.description.value))]), _vm._v(" "), (_vm.pageContactItems) ? _c('div', {
    staticClass: "col-sm-6 no-gutters"
  }, _vm._l((_vm.pageContactItems), function(citems) {
    return _c('div', {
      staticClass: "contact-item"
    }, [_c('h5', {
      staticClass: "item-type"
    }, [_c('strong', [_vm._v(_vm._s(citems.type.value))])]), _vm._v(" "), _c('p', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(citems.name.value))]), _vm._v(" "), _c('p', {
      staticClass: "item-position"
    }, [_vm._v(_vm._s(citems.position.value))]), _vm._v(" "), _c('p', {
      staticClass: "item-email"
    }, [_c('a', {
      attrs: {
        "href": 'mailto:' + citems.email_address.value
      }
    }, [_vm._v(_vm._s(citems.email_address.value))])]), _vm._v(" "), _c('p', {
      staticClass: "item-phone"
    }, [_vm._v(" " + _vm._s(citems.phone_number.value))])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 no-gutters"
  }, [_c('div', {
    staticClass: "primary-address"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.pageContact.elements.agency_address.value)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "map-container",
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "google-map-btn"
  }, [_c('button', {
    staticClass: "btn_orange",
    on: {
      "click": _vm.openMap
    }
  }, [_vm._v("DIRECTIONS")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-right-img col-lg-6 col-md-6 col-sm-6 col-xs-12 hidden-xs hidden-sm hidden-md",
    style: (_vm.setBackgroundImage(_vm.pageContact.elements.image.value[0].url))
  })])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a29c4b4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/Contact.vue
// module id = 1498
// module chunks = 0